import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Switch from "components/Switch";

class TabRanked extends PureComponent {

  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
  }

  onChange(key, value) {
    let data = this.props.data.survey.questionSettings.ranked;
    data[key] = value;

    this.props.onChangeQuestionSettings('ranked', data);
  }

  render() {
    const {errors, data} = this.props;

    return (
      <React.Fragment>
        <FormGroup>
          <Label for="rotateAnswers"><FormattedMessage id="_.question.ranked.rotateAnswers" /></Label>
          <Switch stickToProp checked={data.survey.questionSettings.ranked.rotateAnswers} onChange={value => this.onChange('rotateAnswers', value)} />
        </FormGroup>
      </React.Fragment>
    );
  }
}


TabRanked.propTypes = {
  data: PropTypes.shape({
    survey: PropTypes.shape({
      questionSettings: PropTypes.shape({
        ranked: PropTypes.object.isRequired,
      }).isRequired
    }).isRequired,
  }),
  errors: PropTypes.object.isRequired,
  onChangeQuestionSettings: PropTypes.func.isRequired,
};

export default TabRanked;